import React from 'react';
import './empresa.css';

const Mision = () => {
  return (
    <section id="mision" className="empresa-section">
      <div className="empresa-container">
        <h2 className="empresa-title">Misión</h2>
        <p className="empresa-text">
          Nuestra misión es ofrecer educación artística accesible, práctica y transformadora. Acompañamos a cada estudiante
          en el desarrollo de habilidades creativas mediante contenidos de alta calidad, instructores expertos y una
          comunidad colaborativa que potencia el talento y fomenta oportunidades reales de crecimiento.
        </p>
      </div>
    </section>
  );
};

export default Mision;
